import React from "react"
import get from 'lodash/get'
import set from 'lodash/set'
import clone from 'lodash/clone'
import Searchbar from '../searchbar/searchbar-hardware'
import HardwareTable from '../table/table-hardware'
import { addButton } from '../helper/button'
import { ConfirmSaveForm, AddHardwareForm } from '../form'
import { hardware_type } from '../../project-information/constants/index'

export default class HardwareTab extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'projectByID')
    && JSON.stringify(get(nextProps, 'projectByID')) !== JSON.stringify(prevState.projectByID)
    ) {
      const projectByID = get(nextProps, 'projectByID')
      set(tempState, 'projectByID', projectByID)
      set(tempState, 'hardwares', projectByID.hardwares)
    }
    if (get(nextProps, 'editHardware') !== get(prevState, 'editHardware')) {
      set(tempState, 'editHardware', get(nextProps, 'editHardware'))
    }
    return tempState
  }

  state={
    editHardware: false,
    showAddHardware: false,
    hardwares: [],
    search_hardware: '',
    hardware_name: '',
    hardware_description: '',
    hardware_type: '',
    hardware_sub_project_code: '',
    hardware_cost: 0,
    hardware_price: 0,
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
    && JSON.stringify(this.state) === JSON.stringify(nextState)) return false
    return true
  }

  addHardware = () => {
    const oldHardwares = this.state.hardwares
    const hardware = {}
    let hardwares = []
    hardware.name = this.state.hardware_name
    hardware.description = this.state.hardware_description
    hardware.type = this.state.hardware_type
    hardware.sub_project_code = this.state.hardware_sub_project_code
    hardware.cost = this.state.hardware_cost
    hardware.price = this.state.hardware_price
    hardwares = [...oldHardwares, hardware]
    this.setState({
      hardwares,
      showAddHardware: !this.state.showAddHardware,
    })
  }

  confirmEditHardware = () => {
    const editProjectInformation = get(this.props, 'editProjectInformation')
    const payload = clone(this.state.projectByID)
    delete payload.project_type
    delete payload.created
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload._id
    delete payload.updated_by
    payload.hardwares = this.state.hardwares
    editProjectInformation(payload)
    this.setState({ showConfirmSave: !this.state.showConfirmSave })
    get(this.props, 'clickEditHardware')()
  }

  clickAddHardware = () => {
    this.setState({
      showAddHardware: !this.state.showAddHardware,
      hardware_name: '',
      hardware_description: '',
      hardware_type: hardware_type[0].value,
      hardware_sub_project_code: '',
      hardware_cost: 0,
      hardware_price: 0,
    })
  }

  deleteHardware = (id) => {
    const hardwares = clone(this.state.hardwares)
    hardwares.splice(id, 1)
    this.setState({ hardwares })
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleChangeCost = (e) => {
    const newHardwares = this.state.hardwares
    const hardware = this.state.hardwares[e.target.id]
    const field = e.target.name
    if (field === 'cost' || field === 'price') {
      hardware[field] = parseFloat(e.target.value.replace(/,/g, ''))
    } else {
      hardware[field] = e.target.value
    }
    newHardwares[e.target.id] = hardware
    this.setState({ hardwares: newHardwares })
  }

  /* eslint no-underscore-dangle: 0 */
  render() {
    const getProjectInformationByID = get(this.props, 'getProjectInformationByID')
    const clickEditHardware = get(this.props, 'clickEditHardware')
    return (
      <div style={ { marginLeft: 15, marginRight: 15 } }>
        <AddHardwareForm
          open={ this.state.showAddHardware }
          button={ addButton('addHardware', () => this.addHardware(), () => this.setState({ showAddHardware: !this.state.showAddHardware })) }
          handleInput={ this.handleInput }
          toggle={ () => this.setState({ showAddHardware: !this.state.showAddHardware }) }
          hardware_type={ this.state.hardware_type }
          hardware_cost={ this.state.hardware_cost }
          hardware_price={ this.state.hardware_price }
        />
        <ConfirmSaveForm
          open={ this.state.showConfirmSave }
          toggle={ () => this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          confirmSave={ this.confirmEditHardware }
        />
        <Searchbar
          editHardware={ this.state.editHardware }
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          clickEdit={ () => clickEditHardware() }
          clickAddHardware={ () => this.clickAddHardware() }
          confirmEditHardware={ () =>
            this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          cancelEdit={ () => {
            clickEditHardware()
            this.setState({ projectByID: null })
            getProjectInformationByID()
          } }
        />
        <HardwareTable
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          editHardware={ this.state.editHardware }
          search_hardware={ this.state.search_hardware }
          hardwares={ this.state.hardwares }
          deleteHardware={ this.deleteHardware }
          handleChangeCost={ this.handleChangeCost }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-hardware.js